import { connect } from 'react-redux'
import { createCollaborativeIndexation } from '../../../../../redux/collaborativeIndexations/actions'
import { getCollaborativeIndexationCreationFields } from '../../../../../redux/collaborativeIndexations/selectors'
import Form from './Form.jsx'
import {
    getCollaborativeIndexationCreationCurrentStep,
} from 'redux/collaborativeIndexations/selectors'
import { hasCollaborativeIndexationSelection } from '../../../../../redux/collaborativeIndexations/selectors'
import {
    moveToCollaborativeIndexationCreationStep,
    moveToNextCollaborativeIndexationCreationStep,
    moveToPreviousCollaborativeIndexationCreationStep,
} from '../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch) => ({
    createCollaborativeIndexation: (fields) => dispatch(createCollaborativeIndexation(fields)),
    nextStep: (validation) => dispatch(moveToNextCollaborativeIndexationCreationStep(validation)),
    previousStep: () => dispatch(moveToPreviousCollaborativeIndexationCreationStep()),
    moveToStep: (step, validations) => dispatch(moveToCollaborativeIndexationCreationStep(step, validations)),
})

const mapStateToProps = (state, ownProps) => ({
    fields: getCollaborativeIndexationCreationFields(state),
    currentStep: getCollaborativeIndexationCreationCurrentStep(state),
    hasCollaborativeIndexationSelection: hasCollaborativeIndexationSelection(state),
})

export const FormContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form)
